// common
export const GET_REQUEST = 'reviewNotes/GET_REQUEST'
export const GET_SUCCESS = 'reviewNotes/GET_SUCCESS'
export const GET_FAILURE = 'reviewNotes/GET_FAILURE'
export const DELETE_REQUEST = 'reviewNotes/DELETE_REQUEST'
export const DELETE_SUCCESS = 'reviewNotes/DELETE_SUCCESS'
export const DELETE_FAILURE = 'reviewNotes/DELETE_FAILURE'

export const UPDATE_NOTES = 'reviewNotes/UPDATE_NOTES'
export const UPDATE_PAGE_NOTE_LIST = 'reviewNotes/UPDATE_PAGE_NOTE_LIST'